import React, { useEffect, useRef, useState } from 'react';
import displayINRCurrency from '../helpers/displayCurrency';
import { FaAngleLeft, FaAngleRight } from 'react-icons/fa6';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import AdminEditProduct from './AdminEditProduct';
import { MdModeEditOutline, MdDelete } from 'react-icons/md';
import SummaryApi from '../common';
import { toast } from 'react-toastify';
import adminFetchAlternativeProduct from '../helpers/adminFetchAlternativeProduct';
import defaultImage from '../assest/DAWACO_White_Icon.png'


const AdminAlterCardProduct = ({ type,activePharmaceuticalIngredient,id, heading }) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [scroll, setScroll] = useState(0);
    const [editProduct, setEditProduct] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [confirmationVisible, setConfirmationVisible] = useState(false);
    const [productToDelete, setProductToDelete] = useState(null);

    const scrollElement = useRef();
    const params = useParams();
    const loadingList = new Array(13).fill(null);

    const fetchData = async () => {
        setLoading(true);
        const alternativeProduct = await adminFetchAlternativeProduct(type,activePharmaceuticalIngredient,id);
        setLoading(false);
        setData(alternativeProduct?.data);
    };
    useEffect(() => {
        fetchData();
    }, [activePharmaceuticalIngredient,id]);

    const scrollRight = () => {
        scrollElement.current.scrollLeft += 300;
    };

    const scrollLeft = () => {
        scrollElement.current.scrollLeft -= 300;
    };

    const openEditProduct = (product) => {
        setSelectedProduct(product);
        setEditProduct(true);
    };

    const handleDeleteClick = (product) => {
        setProductToDelete(product);
        setConfirmationVisible(true);
    };
    const deleteFromCart = async (id) => {

        const response = await fetch(SummaryApi.deleteFromCart.url, {
          method: SummaryApi.deleteFromCart.method,
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            productId: id,
          }),
        });
    
        const responseData = await response.json();
    
        
    
    };

    const handleDelete = async (id,type) => {
        try {
            await deleteFromCart(id);
            const response = await fetch(SummaryApi.deleteProduct.url, {
              method: SummaryApi.deleteProduct.method,
              credentials: 'include',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                id: id,
                type:type,
              }),
            });

            const responseData = await response.json();

            if (responseData.success) {
                toast.success('تم حذف المنتج بنجاح');
                setConfirmationVisible(false);
                fetchData(); // Refresh data
            } else {
                toast.error('فشل في حذف المنتج');
            }
        } catch (error) {
            toast.error('حدث خطأ اثناء حذف المنتج');
        }
    };

    const handleLinkClick = (event) => {
        // Prevent default link behavior
        event.preventDefault();
    
        // Reload the page
       window.location.href = event.currentTarget.href;
    };

    return (
        <div className='container mx-auto px-4 my-6 relative'>
            <h2 className='text-2xl font-semibold py-4'>{heading}</h2>

            <div className='flex items-center gap-4 md:gap-6 overflow-scroll scrollbar-none transition-all' ref={scrollElement}>
                <button className='bg-white shadow-md rounded-full p-1 absolute left-0 text-lg hidden md:block' onClick={scrollLeft}><FaAngleLeft /></button>
                <button className='bg-white shadow-md rounded-full p-1 absolute right-0 text-lg hidden md:block' onClick={scrollRight}><FaAngleRight /></button>
                {loading ? (
                    loadingList?.map((_, index) => (
                        <div key={index} className='w-full min-w-[280px] md:min-w-[320px] max-w-[280px] md:max-w-[320px] h-36 bg-white rounded-sm shadow flex'>
                            <div className='bg-slate-200 h-full p-4 min-w-[120px] md:min-w-[145px] animate-pulse'></div>
                            <div className='p-4 grid w-full gap-2'>
                                <h2 className='font-medium text-base md:text-lg text-ellipsis line-clamp-1 text-black bg-slate-200 animate-pulse p-1 rounded'></h2>
                                <p className='capitalize text-slate-500 p-1 bg-slate-200 animate-pulse rounded'></p>
                                <div className='flex gap-3 w-full'>
                                    <p className='text-blue-600 font-medium p-1 bg-slate-200 w-full animate-pulse rounded'></p>
                                    <p className='text-slate-500 line-through p-1 bg-slate-200 w-full animate-pulse rounded'></p>
                                </div>
                                <button className='text-sm text-white px-3 py-0.5 rounded w-full bg-slate-200 animate-pulse'></button>
                            </div>
                        </div>
                    ))
                ) : (
                    data.map((product, index) => {
                        const isOutOfStock = product?.quantity <= 0;

                        return (
                            <div key={index} className='w-full min-w-[500px] max-w-[500px] h-[200px] bg-white rounded-sm shadow flex relative'>
                                <div className='w-[330px] h-full bg-slate-200 flex items-center justify-center overflow-hidden'>
                                <Link 
                                    to={type === "Medicine" 
                                        ? `/admin-product/${product?._id}` 
                                        : type === "Cosmetic" 
                                        ? `/admin-cosmetic-product/${product?._id}` 
                                        : `/`} 
                                    onClick={handleLinkClick} // Add this onClick event to call fetchdata when link is clicked
                                >
                                        <img src={product?.productImage[0]||defaultImage} className='object-cover h-full w-full' alt={product?.productName} />
                                    </Link>
                                </div>
                                <div className='p-4 flex flex-col justify-between w-full'>
                                <Link 
                                    to={type === "Medicine" 
                                        ? `/admin-product/${product?._id}` 
                                        : type === "Cosmetic" 
                                        ? `/admin-cosmetic-product/${product?._id}` 
                                        : `/`} 
                                    onClick={handleLinkClick} // Add this onClick event to call fetchdata when link is clicked
                                >
                                        <h2 className='font-medium text-base text-ellipsis overflow-hidden whitespace-nowrap'>{product?.productName}</h2>
                                        <p className='capitalize text-slate-500'>{product?.category} : العلامة التجارية</p>
                                        <p className='capitalize text-slate-500'>{product?.activePharmaceuticalIngredient} : الماده الفعالة</p>
                                        <p className='capitalize text-slate-500'>{product?.quantity} : الكمية</p>
                                        <p className='capitalize text-slate-500'>النوع : {product?.status === "Promo Pack" ? "العروض المجمعة" :
                                        product?.status === "New Arrival" ? "منتجات حديثة الوصول" :
                                        product?.status === "Sale" ? "التخفيضات" :
                                        product?.status === "Default" ? "افتراضي" :
                                        product?.status} </p>
                                        

                                        
                                        
                                        
                                        <div className='flex gap-3 mt-2'>
                                            {product.sellingPrice > 0 ? (
                                                <>
                                                    <p className='text-blue-800 font-medium'>{displayINRCurrency(product.sellingPrice)}</p>
                                                    <p className='text-slate-500 line-through'>{displayINRCurrency(product.price)}</p>
                                                </>
                                            ) : (
                                                <p className='text-blue-800 font-medium'>{displayINRCurrency(product.price)}</p>
                                            )}
                                        </div>
                                    </Link>
                                    <div className='absolute top-2 right-10 p-2 bg-blue-100 hover:bg-blue-800 rounded-full hover:text-white cursor-pointer' onClick={() => openEditProduct(product)}>
                                        <MdModeEditOutline />
                                    </div>
                                    <div className='absolute top-2 right-2 p-2 bg-red-100 hover:bg-red-800 rounded-full hover:text-white cursor-pointer' onClick={() => handleDeleteClick(product)}>
                                        <MdDelete />
                                    </div>
                                    {isOutOfStock && (
                                        <span className='text-sm text-red-500 mt-2'>غير متاح حاليا بالمخزن</span>
                                    )}
                                </div>
                            </div>
                        );
                    })
                )}
            </div>

             {/* Confirmation Dialog */}
{confirmationVisible && (
    <div className='fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50'>
        <div className='bg-white p-8 rounded-lg shadow-lg w-full max-w-md relative'>
            <h3 className='text-lg font-semibold mb-4'>؟{productToDelete?.productName} هل متاكد من حذف</h3>
            <div className='flex gap-4'>
                <button className='bg-red-500 text-white px-4 py-2 rounded' onClick={() => handleDelete(productToDelete._id,type)}>نعم</button>
                <button className='bg-gray-300 px-4 py-2 rounded' onClick={() => setConfirmationVisible(false)}>لا</button>
            </div>
            {/* Optional Close Button */}
            <button 
                className='absolute top-2 right-2 text-gray-500 hover:text-gray-700'
                onClick={() => setConfirmationVisible(false)}
            >
                &times;
            </button>
        </div>
    </div>
)}


            {/* Modal for Editing Product */}
            { editProduct&& (
                <div className='fixed inset bg-black bg-opacity-50 flex items-center justify-center z-50'>
                    <div className='bg-white p-8 rounded-lg shadow-lg w-full max-w-3xl relative'>
                        <AdminEditProduct userType={type} productData={selectedProduct} onClose={() => setEditProduct(false)} fetchdata={fetchData} condition={false} />
                    </div>
                </div>
            )}

           
        </div>
    );
};

export default AdminAlterCardProduct;
